// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ScrollView__root___J77wS"};